export default "__VITE_ASSET__Bdjv242Y__"